export const budgetPercentage = (amount, total) => total > 0 ? Math.min(100, Math.max(0, amount / total * 100)) : 0;
